// extracted by mini-css-extract-plugin
export default {"wrapper":"EditableInputBordered_wrapper__I4Xma","title":"EditableInputBordered_title__VobKl","editBlock":"EditableInputBordered_editBlock__3GK0x"};